import { SeoLandingLayout, SeoLandingPageData } from '../../../components/SeoLandingLayout';

const data: SeoLandingPageData = {
  seo: {
    title: 'Stress test trésorerie : testez la résistance financière de votre structure | Trezoone',
    description: 'Le stress test de trésorerie simule des scénarios de crise pour mesurer votre résistance financière. Découvrez combien de temps vous tiendriez en cas de choc.',
    canonical: '/stress-test-tresorerie',
    keywords: 'stress test trésorerie, test résistance financière, simulation crise trésorerie, survie financière, scénario catastrophe trésorerie',
  },
  hero: {
    tag: 'Stress test trésorerie',
    title: 'Si votre principal financeur coupait les fonds demain, combien de semaines vous tiendriez ?',
    subtitle: 'Le stress test de trésorerie répond à cette question en quelques secondes. C\'est l\'outil qui distingue les structures préparées de celles qui découvrent les problèmes trop tard.',
    ctaLabel: 'Faire mon stress test',
  },
  pilierLink: { label: 'Stress test (fonctionnalité)', href: '/fonctionnalites/stress-test-tresorerie' },
  sections: [
    {
      type: 'explain',
      title: 'Qu\'est-ce qu\'un stress test de trésorerie ?',
      content: 'Un stress test de trésorerie simule des scénarios défavorables pour mesurer votre résistance :',
      items: [
        'Scénario 1 : perte de votre principal client ou financeur',
        'Scénario 2 : baisse de l\'activité de 30 % pendant 3 mois',
        'Scénario 3 : retard de toutes les subventions de 2 mois',
        'Scénario 4 : hausse des charges de 20 % (matières premières, énergie…)',
        'Pour chaque scénario : combien de temps vous tenez ? Quel est le déficit à financer ?',
      ],
    },
    {
      type: 'example',
      title: 'Résultats d\'un stress test pour une association culturelle',
      content: 'Association avec 3 financeurs (Mairie 40%, Région 35%, Europe 25%). Budget 180 000 €.',
      items: [
        'Scénario "perte financeur Mairie" : rupture de trésorerie en 4 mois → déficit à couvrir 72 000 €',
        'Scénario "retard subventions 3 mois" : point critique atteint en semaine 8',
        'Scénario "réduction de 20%" : activité tenable 7 mois puis restructuration nécessaire',
        'Résultat : 3 risques identifiés et quantifiés → 3 plans de contingence à préparer',
      ],
    },
    {
      type: 'midcta',
      title: 'Connaissez votre seuil de résistance avant la prochaine crise — pas après',
      content: 'Trezoone simule vos scénarios de rupture en quelques secondes et calcule votre temps de survie financière en temps réel.',
    },
    {
      type: 'solution',
      title: 'Trezoone : le stress test automatisé',
      content: 'Trezoone calcule automatiquement votre TSF (Temps de Survie Financière) et vous permet de simuler des scénarios de crise.',
      items: [
        'TSF calculé en temps réel : combien de semaines de charges vous tenez',
        'Simulation de perte de recettes (chiffrer l\'impact en secondes)',
        'Simulation de hausse de charges sur votre trésorerie future',
        'Comparaison de plusieurs scénarios sur une même vue',
        'Rapport stress test pour vos financeurs ou votre CA',
      ],
    },
    {
      type: 'cluster',
      title: 'Anticiper et se préparer aux crises de trésorerie',
      links: [
        { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
        { label: 'Manque de trésorerie', href: '/manque-tresorerie' },
        { label: 'Problème cash flow', href: '/probleme-cash-flow' },
        { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
        { label: 'Simulateur trésorerie', href: '/simulateur-tresorerie-association' },
        { label: 'Simulation trésorerie association', href: '/simulation-tresorerie-association' },
        { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
        { label: 'Gestion trésorerie', href: '/gestion-tresorerie' },
      ],
    },
    {
      type: 'cta',
      title: 'Connaissez votre seuil de résistance avant la crise',
      content: 'Stress test inclus dans Trezoone. Essai gratuit 14 jours.',
    },
  ],
  relatedLinks: [
    { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
    { label: 'Manque de trésorerie', href: '/manque-tresorerie' },
    { label: 'Problème cash flow', href: '/probleme-cash-flow' },
    { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
    { label: 'Simulateur trésorerie', href: '/simulateur-tresorerie-association' },
    { label: 'Simulation trésorerie association', href: '/simulation-tresorerie-association' },
    { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
    { label: 'Gestion trésorerie', href: '/gestion-tresorerie' },
  ],
};

interface Props { onNavigate?: (p: string) => void; onSignIn?: () => void; onSignUp?: () => void; }
export default function StressTestTresorerieSeoPage({ onNavigate, onSignIn, onSignUp }: Props) {
  return <SeoLandingLayout data={data} onNavigate={onNavigate} onSignIn={onSignIn} onSignUp={onSignUp} />;
}
